<template>
  <va-create-layout>
    <chapters-form :title="title" :book="parent"></chapters-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "parent", "item"],
};
</script>
